import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import {IOption} from 'ng-select';
import * as moment from 'moment/moment';
import { AlertComponent } from './../alert/alert.component';
import { DialogComponent,DialogService } from 'ng2-bootstrap-modal';
import { Popup } from 'ng2-opd-popup';

@Component({
  selector: 'app-checklistdetails',
  templateUrl: './check-list-details.component.html',
  styleUrls: ['./check-list-details.component.scss']
})


export class CheckListDetailsComponent implements OnInit {
	no:number=0;
	loading:boolean=true;
	myFormsOptionsChecklistName:Array<IOption>=[];
	checkListNameplaceholder="Select a ChecklistName"
	JsonData:any[] = [];
	formName:any[] = [];
	fields:any[] = [];
	values:any[] = [];
	entryValue:any;
	public EditData:any[]=[];
	public button = 'Save';
	public EditIndex:any;
	public UpdateKey:any;
	existAddedUserId:number;
	keyValue:any;
    ListOfCustomerMaster:any[] = [];
	btnName:any='Submit';
	EditObjectId:any;
	MasterId:number;
	msgtext:string;
	ListdropdownDetails:any[] = [];
	ListdropdownValues:any[] = [];
	ListOfCheckListDetails:any[] = [];
	ListMultipleFieldTableList:any[] = [];
	startingCount:number = 0;
  	endingCount:number = 0;
  	p: number = 1;
  	checkListMaster: Array<IOption> = [];
  	checkListNameId:any[]=[];
  	ListCheckLists:any[] = [];
  	ListOfCheckListMaster:any[] = [];
  	checkListName:any;
  	checkListName_err:boolean=false;
    isValid:boolean = true;
    issueType:boolean = false;
	item:boolean = false;
	jobDescription:boolean = false;
	changelevel_err:boolean = false;
	wsre_err:boolean = false;
	changeLevel:any;
	wsre:any;
	mysqlEntryCheckListdetailArr = [];
	mysqlEntryUpdateListArr = [];
	@ViewChild('delete') delete: Popup;
	@ViewChild('addpop') addpop: Popup;
	@ViewChild('update') update: Popup;
	deleteId:number;
    orgId:number;
	userId:number; 

	constructor(private dialogService:DialogService,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private http: Http,private router:Router,private route : ActivatedRoute){}

	ngOnInit() {
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
		this.getAllDetailsFromCheckListdetails();
		this.getAllDetailsFromCheckListMaster ();
		this.ListCheckLists.push({
			'issueType':'',
			'item':'',
			'jobDescription':''
		});
		this.loading=false;
	}

	showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"CheckList Details",message:"The Data Added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"CheckList Details",message:"The Data Updated successfully"});
	}

	add() {
		this.ListCheckLists.push({
			'issueType':'',
			'item':'',
			'jobDescription':''
		});
	}

	minus(index) {
		this.ListCheckLists.splice(index, 1);
			if(this.ListCheckLists.length==0) {
				this.ListCheckLists.push({
				'issueType':'',
				'item':'',
				'jobDescription':''
			});
		}
		
	}

	No() {
      this.delete.hide();
    }
    addOk() {
      this.addpop.hide();
    }
    updateOk() {
      this.update.hide();
    }

	// backToMyForm() {
 //      this.router.navigate(['myform']);
 //    }

    getAllDetailsFromCheckListMaster () {
    	let CLObj = {
	      'orgId':this.orgId
	    }
  		return this.http.post('/api/getCheckListMasterDetails', CLObj).subscribe(
     	res => {
			 this.ListOfCheckListMaster = res.json();
			 let pusharr=[];
			 for(let i=0;i<this.ListOfCheckListMaster.length;i++){
				 pusharr.push({'value':this.ListOfCheckListMaster[i].checklistmasterId.toString(),'label':this.ListOfCheckListMaster[i].CHECK_LIST_NAME.toUpperCase()});
			 }
			 this.myFormsOptionsChecklistName=pusharr;
      },(err) =>{
        if(err.status != 200){
          this.msgtext = "Unable to load the check list master Value";
          this.getWarningFunction(this.msgtext);
        }
      })
  		
  	}

	getAllDetailsFromCheckListdetails () {
		let reqCheckList = {
			'orgId':this.orgId
		}
  		return this.http.post('/api/getCheckListDetails', reqCheckList).subscribe(
     	res => {
     	
     		let Response = res.json();
     		for (var i=0;i<Response[0].check_list_details.length;i++) {
     			for (var j=0;j<Response[1].check_list_master.length;j++) {
     				if(Response[0].check_list_details[i].checklistMaster_Id == Response[1].check_list_master[j]._id) {
     					Response[0].check_list_details[i].checkListName = Response[1].check_list_master[j].checklist_Name;
     				}
     			}
     		}

     		this.ListOfCheckListDetails = Response[0].check_list_details;
     		this.getCount()
      	},(err) =>{
	        if(err.status != 200){
	          this.msgtext = "Unable to load the check list details Value";
	          this.getWarningFunction(this.msgtext);
	        }
      	})
  	}

	

	getCount(){
	   if(this.p < Math.ceil(this.values.length/10)){
	     this.startingCount = (this.p-1)*10;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	     }
	     this.endingCount = this.p*10;
	   } else if(this.p == Math.ceil(this.values.length/10)){
	     let count = this.values.length%10;
	     this.startingCount = (this.p-1)*10;
	     this.endingCount = this.startingCount + count;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	       this.endingCount = count;
	     }
	   }
	}


	chooseCheckListName(value) {
		if(value.trim() == "" || value.trim() == undefined || value.trim() == null){
	      this.checkListName_err = true;
	      this.isValid = false;
	    } else {
	      this.checkListName_err = false;
	      this.isValid = true;
	    }
	}

	InputIssueType(value) {
		if(value == "" || value == undefined || value == null) {
			this.isValid = false;
		} else {
			this.isValid = true;
		}
	}

	InputchangeLevel(value) {
		if(value == "" || value == undefined || value == null) {
			this.isValid = false;
			this.changelevel_err=true;
		} else {
			this.isValid = true;
			this.changelevel_err=false;
		}
	}

	InputWSRE(value) {
		if(value == "" || value == undefined || value == null) {
			this.isValid = false;
			this.wsre_err=true;
		} else {
			this.isValid = true;
			this.wsre_err=false;
		}
	}

	_keyPress(event: any) {
	    const pattern = /[0-9\.\ ]/;
	    let inputChar = String.fromCharCode(event.charCode);

	    if (!pattern.test(inputChar)) {
	      // invalid character, prevent input
	      event.preventDefault();
	      
	    }
	  }

	addCheckListdetails() {
		
		//this.spinner.show();
		this.loading=true;
		this.mysqlEntryCheckListdetailArr = [];
		this.mysqlEntryUpdateListArr = [];
		let dataValue;
		let Arrvalidation=0;
		for(var i=0;i<this.ListCheckLists.length;i++) {
			// if(this.ListCheckLists[i].issueType.trim() == "" ||  this.ListCheckLists[i].issueType.trim() == null || this.ListCheckLists[i].issueType.trim() == undefined) {
			// 	this.issueType = true;
			// 	Arrvalidation=1;
			// } 
			if (this.ListCheckLists[i].item.trim() == "" || this.ListCheckLists[i].item.trim()== null || this.ListCheckLists[i].item.trim() == undefined) {
				this.item = true;
				Arrvalidation=1;
			} 
			if (this.ListCheckLists[i].jobDescription.trim() == "" || this.ListCheckLists[i].jobDescription.trim() == null || this.ListCheckLists[i].jobDescription.trim() == undefined) {
				this.jobDescription = true;
				Arrvalidation=1;
			}
		}
		
		if(this.checkListName == "" || this.checkListName == null || this.checkListName == undefined) {
			this.checkListName_err = true;
			this.isValid = false;
			//this.spinner.hide();
			this.loading=false;
			//this.msgtext = "choose the Check List Name";
   			//this.getWarningFunction(this.msgtext);
  			document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
		} else if((this.changeLevel != 0) && (this.changeLevel == "" || this.changeLevel == null || this.changeLevel == undefined)) {
			this.changelevel_err=true;
			this.isValid = false;
			//this.spinner.hide();
			this.loading=false;
			document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
		} else if(this.wsre == "" || this.wsre == null || this.wsre == undefined) {
			this.wsre_err=true;
			this.isValid = false;
			//this.spinner.hide();
			this.loading=false;
			document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
		}else if (Arrvalidation == 1) {
			this.isValid = false;
			//this.issueType = true;
			//this.spinner.hide();
			this.loading=false;
			document.body.scrollTop = 0;
        	document.documentElement.scrollTop = 0;
		}else {
			this.checkListName_err = false;
			this.isValid = true;
			//this.issueType = false;
			this.item = false;
			this.jobDescription = false;
			let RequiredLabelArr = [];
      		let RequiredLabelObj = {};
			for(var i=0;i<this.ListCheckLists.length;i++) {
				let obj = {
					'issueType':this.ListCheckLists[i].issueType,
					'item':this.ListCheckLists[i].item,
					'jobDescription':this.ListCheckLists[i].jobDescription
				}
				RequiredLabelArr.push(obj);
				this.mysqlEntryCheckListdetailArr.push([this.checkListName,this.ListCheckLists[i].issueType,this.ListCheckLists[i].item,this.ListCheckLists[i].jobDescription,0,this.orgId,this.userId,moment.utc().format('YYYY-MM-DD h:mm:ss')])
				this.mysqlEntryUpdateListArr.push([this.checkListName,this.ListCheckLists[i].issueType,this.ListCheckLists[i].item,this.ListCheckLists[i].jobDescription,0,this.orgId,this.userId,this.userId,moment.utc().format('YYYY-MM-DD h:mm:ss'),moment.utc().format('YYYY-MM-DD h:mm:ss')])
		    }

		    
		    if(this.EditObjectId == undefined || this.EditObjectId == null || this.EditObjectId == "") {
		    	let RequiredADDObj = {
			        'check_List_Name':this.checkListName,
			        'changelevel':this.changeLevel,
			        'wsre':this.wsre,
					'RequiredLabelObj':RequiredLabelArr,
					'orgId':this.orgId,
			        'created_By':this.userId,
			        'created_Date':moment.utc().format('YYYY-MM-DD h:mm:ss')
		      	}
		    	return this.http.post('/api/addCheckListDetails', RequiredADDObj).subscribe(
		        res => {
		        	let Response = res.json();
		            if(Response.response == 'Check List Name Already Exist') {
					 //  this.spinner.hide();
					 this.loading=false;
		              	alert('This Check List Name already exist');
		            } else {
		            	this.MYSQLEntryAddcheckListdetails();
		            }
		        },(err)=>{
					//this.spinner.hide();
					this.loading=false;
		        	if(err.status != 200) {
			            this.msgtext = "Unable to Add the Data";
			            this.getWarningFunction(this.msgtext);
		          	}
		          	console.log(err);
		        })
		    } else {
		    	let RequiredUpdateObj = {
			        'check_List_Name':this.checkListName ,
			        'RequiredLabelObj':RequiredLabelArr,
			        'changelevel':this.changeLevel,
			        'wsre':this.wsre,
			        'EditObjectId':this.EditObjectId,
			        'orgId':this.orgId,
			        'updated_By':this.userId,
			        'updated_Date':moment.utc().format('YYYY-MM-DD h:mm:ss')
			    }
		    	return this.http.post('/api/UpdateChecklistDetails', RequiredUpdateObj).subscribe(
		        res => {
		        	let Response = res.json();
		            if(Response.response == 'Check List Name Already Exist') {
					  //  this.spinner.hide();
					  this.loading=false;
		                alert('This Check List Name already exist');
		            } else {
		            	this.MYSQLEntryUpdatecheckListdetails();
		            }
		        },(err)=>{
					//this.spinner.hide();
					this.loading=false;
		        	if(err.status != 200) {
			            this.msgtext = "Unable to Add the Data";
			            this.getWarningFunction(this.msgtext);
			        }
		          console.log(err);
		        })
		    }

	      	
		} //else end here
	}

	MYSQLEntryAddcheckListdetails() {
		let MysqlRequiredADDObj = {
	        'check_List_Name':this.checkListName,
			'RequiredLabelObj':this.mysqlEntryCheckListdetailArr,
		}
    	return this.http.post('/api/MYSQLaddCheckListDetails', MysqlRequiredADDObj).subscribe(
        res => {
			//this.spinner.hide();
			this.loading=false;
        	// this.addpop.options = {
	        //     showButtons: false, 
	        //     color: "#4180ab",
	        //     header: "Check List Creation/Updation"
	        // };
			// this.addpop.show(this.addpop.options);
			this.showAlertForAddingdata();
	        this.getAllDetailsFromCheckListdetails();
	        this.getEmpty();
        },(err)=>{
			//this.spinner.hide();
			this.loading=false;
        	this.msgtext = "Unable to Add the Data In Mysql";
			this.getWarningFunction(this.msgtext);
        })
	}

	MYSQLEntryUpdatecheckListdetails() {
		let RequiredUpdateObj = {
			'RequiredLabelObj':this.mysqlEntryUpdateListArr,
	        'EditObjectId':this.EditObjectId,
	        'orgId':this.orgId,
	    }
    	return this.http.post('/api/MYSQLUpdateChecklistDetails', RequiredUpdateObj).subscribe(
        res => {
			//this.spinner.hide();
			this.loading=false;
        	// this.update.options = {
            //     showButtons: false, 
            //     color: "#4180ab",
            //     header: "Check List Creation/Updation"
            // };
			// this.update.show(this.update.options);
			this.showAlertForUpdatingdata();
            this.getAllDetailsFromCheckListdetails();
            this.getEmpty();
        },(err)=>{
			//this.spinner.hide();
			this.loading=false;
        	this.msgtext = "Unable to Update the Data In Mysql";
			this.getWarningFunction(this.msgtext);
        })
	}

	getEmpty() {
		this.ListCheckLists = [];
        this.ListCheckLists.push({
			'issueType':'',
			'item':'',
			'jobDescription':''
		});	  	
		this.EditObjectId = "";
		this.checkListName="";
		this.changeLevel="";
		this.wsre="";
		this.checkListName_err = false;
		this.isValid = true;
		this.issueType = false;
		this.item = false;
		this.jobDescription = false;
		this.changelevel_err = false;
		this.wsre_err = false;
		this.btnName = 'Submit';
		this.checkListNameplaceholder="Select a ChecklistName";
	}

	reset() {
		this.getEmpty();
	}

	Editing(IndexCount,ObjectId) {
		//this.spinner.show();
		this.loading=true;
		document.body.scrollTop = 0;
    	document.documentElement.scrollTop = 0;
	  	this.EditObjectId = ObjectId;
	  	this.btnName = 'Update';
	  	let ReqObj = {
	  		'data':this.EditObjectId
	  	}
	  	return this.http.post('/api/getCheckListDetailsBasedOnId', ReqObj).subscribe(
	      res => {
	
		  this.loading=false;
	      	res.json();
	      	let ResponseData = res.json();
	      	if(ResponseData.length>0) {
	      		this.checkListName = ResponseData[1].Id.toString().toUpperCase();
		      	this.changeLevel = ResponseData[1].changeLevel;
		      	this.wsre = ResponseData[1].Wsre;
				this.ListCheckLists = ResponseData[0].label;
	      	} else {
	      		alert('No records');
	      	}
	    },(err)=>{
			//this.spinner.hide();
			this.loading=false;
			this.msgtext = "Unable to get the Data";
			this.getWarningFunction(this.msgtext);
		})
	  	
	}


	Delete(IndexCount, ObjectId) {
		document.body.scrollTop = 0;
    	document.documentElement.scrollTop = 0;
		this.deleteId = ObjectId;
	    this.delete.options = {
	      showButtons: false, // You can hide this in case you want to use custom 
	      color: "#4180ab",
	      header: "Confirm Delete"
	    };
	    this.delete.show(this.delete.options);
	}

	Yes() {
		//this.spinner.show();
		this.loading=true;
		this.delete.hide();
		let deleteObj = {
	  		'data':this.deleteId
	  	}
	  	return this.http.post('/api/deleteCheckListDetails', deleteObj).subscribe(
	      res => {
	      	this.MYSQLEntryDeleteCheckListdetails();
        },(err)=>{
			//this.spinner.hide();
			this.loading=false;
        	this.msgtext = "Unable to delete the Data";
			this.getWarningFunction(this.msgtext);
        })
	}

	MYSQLEntryDeleteCheckListdetails() {
		let deleteObj = {
	  		'data':this.deleteId
	  	}
	  	return this.http.post('/api/MYSQLdeleteCheckListDetails', deleteObj).subscribe(
	      res => {
			  //this.spinner.hide();
			  this.loading=false;
	      	alert('Delete Successfully');
	      	this.EditObjectId = "";
	      	this.getAllDetailsFromCheckListdetails();
	      	this.getEmpty();
		    this.delete.hide();
	    },(err)=>{
			//this.spinner.hide();
			this.loading=false;
	    	this.msgtext = "Unable to delete the Data In mysql";
			this.getWarningFunction(this.msgtext);
	    })
	}


	getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "Check List Creation/Updation",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	      };
	    this.toastyService.warning(toastOptions);
	}//getWarningFunction end here


	getSuccessFunction(successMsg){
	    var toastOptions:ToastOptions = {
	      title: "Check List Creation/Updation",
	      msg: successMsg,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	    };
	    this.toastyService.success(toastOptions);
	}//getSuccessFunction end here
}


// WEBPACK FOOTER //
// ./client/app/check-list-details/check-list-details.component.ts